<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate [style.backgroundImage]="'url('+ getRandomBackground() +')'">
  <div fxLayout="row" fxLayoutAlign="center center" [class.loading]="loading">
    <mat-card class="elevated">
      <mat-card-title>
        <div class="center title">
          <img src="assets/logo_.png" alt="Logo" id="header-logo" class="center">
          <p class="center title-text">Inloggen bij de DLA Access monitor</p>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div class="center content">
          <p>
            @if (error) {
              <span class="error-message">
                <mat-icon>error_outline</mat-icon> {{error}}
              </span>
            }
          </p>
          <!-- name -->
          <p>
            <mat-form-field class="login-form-field">
              <mat-label>E-mail adres</mat-label>
              <input matInput formControlName="Name">
            </mat-form-field>
          </p>

          <!-- password -->
          <p>
            <mat-form-field class="login-form-field">
              <mat-label>Wachtwoord</mat-label>
              <input type="password" matInput formControlName="Password">
            </mat-form-field>
            <a class="forgot-password" (click)="openForgotPasswordDialog()">Heeft u geen toegang tot uw account?</a>
          </p>

          <button class="submit-button" mat-flat-button type="submit" color="primary" [disabled]="!form.valid || form.pristine">Login</button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</form>

@if (loading) {
  <div class="loader" fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner [mode]="'indeterminate'">
    </mat-spinner>
  </div>
}